import { useCrudActions } from '@/common/view/useCrudActions';
import { useLocale } from '@/modules/locale/model/locale';
import { duplicateService } from '@/services/duplicate';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useDuplicateItemTranslate() {
    const route = useRoute();
    const crudAction = useCrudActions();

    const { localeSupportedOptions, getListSupported } = useLocale();

    const model = reactive({
        id: route.params.id,
        locale: null,
        title: '',
        hasData: false
    });

    const validations = {
        title: { required },
        locale: { required }
    };

    const v$ = useVuelidate(validations, model);

    const beforeFetch = async () => {
        await getListSupported();
    };

    const fetch = crudAction.executeAction({
        canExecute: () => model.locale != null,
        request: () => duplicateService.item.getText(model.id, model.locale),
        onSuccess: ({ data }) => {
            model.hasData = true;
            model.title = data.title;
        },
        onError: () => {
            model.hasData = false;
            model.title = '';
        }
    });

    const actions = {
        updateText: crudAction.excuteAndNotify({
            validator: v$,
            request: () => duplicateService.item.updateText(model.id, model.locale, model.title),
            onSuccess: fetch
        }),
        removeText: crudAction.confirmAndRemove({
            request: () => duplicateService.item.removeText(model.id, model.locale),
            onSuccess: fetch
        })
    };

    return { model, v$, fetch, beforeFetch, actions, localeSupportedOptions };
}
